const localizers = {
  'Alerts.noAlerts.txt': () => `Nije podešeno nijedno upozorenje za ovaj izveštaj.`,
  'BirdImage.image.txt': () => `Slika`,
  'ComboBox.clearFilter.txt': () => `Obriši filter`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Nema podataka)`,
  'ContextMenu.selectAll.txt': () => `Izaberi sve`,
  'ContextMenu.clearSelection.txt': () => `Obriši izbor`,
  'ContextMenu.exportImage.txt': () => `Izvezi kao sliku`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Rastućim redosledom`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Opadajućim redosledom`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Dodaj rastućim redosledom`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Dodaj opadajućim redosledom`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Ukloni ${role} iz sortiranja`,
  'ContextMenu.removeSortLevel.txt': () => `Ukloni nivo sortiranja`,
  'ContextMenu.sort.txt': () => `Sortiraj`,
  'ContextMenu.selectShortestPath.txt': () => `Izaberi najkraću putanju`,
  'ContextMenu.explain.txt': () => `Objasnite podatke`,
  'ContextMenu.explainRole.txt': ({role}) => `Objasnite ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Upravljanje kolonama`,
  'ContextMenu.includeMissingValues.txt': () => `Obuhvati vrednosti koje nedostaju`,
  'DrillableTooltip.drill.txt': () => `DUBINSKI PRETRAŽI`,
  'DrillableTooltip.tooltip.txt': () => `OPIS ELEMENTA`,
  'DrillableTooltip.links.txt': () => `VEZE`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Veza stranice ka ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Veza izveštaja ka ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Spoljna veza ka ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Nedostupno`,
  'Breadcrumb.all.fmt': ({label}) => `Sve ${label}`,
  'BrowserCheck.title.txt': () => `WebGL provera`,
  'BrowserCheck.msg.txt': () => `WebGL je onemogućen ili ga vaš pregledač ne podržava.   \nKliknite na „U redu” da biste videli izveštaj u klasičnoj aplikaciji za prikaz.`,
  'EmailUtil.subject.multiple.txt': () => `Izveštaji za pregled`,
  'EmailUtil.tooLongEmail.txt': () => `Ograničenje dužine e-poruke je prekoračeno. Izaberite manje izveštaja za slanje e-poštom.`,
  'HiddenSectionDialog.close.txt': () => `Zatvori`,
  'HiddenSectionDialog.export.txt': () => `Izvezi kao PDF`,
  'InfoPanel.information.txt': () => `Informacije`,
  'InfoPanel.comments.txt': () => `Komentari`,
  'InfoPanel.alerts.txt': () => `Upozorenja`,
  'IncomingFilters.promptbars.txt': () => `Trake odziva`,
  'Information.title.txt': () => `Naslov`,
  'Information.name.txt': () => `Ime:`,
  'Information.description.txt': () => `Opis:`,
  'Information.displayRules.txt': () => `Pravila prikaza:`,
  'Information.graphLevel.txt': () => `Nivo grafikona`,
  'Information.reportLevel.txt': () => `Nivo izveštaja`,
  'Information.legend.txt': () => `Legenda`,
  'Information.incomingFilters.txt': () => `Dolazni filteri:`,
  'Information.noIncomingFilters.txt': () => `Nema dolaznih filtera`,
  'Information.dataSourceFilters.txt': () => `Filteri izvora podataka:`,
  'Information.interactiveFilters.txt': () => `Interaktivni filteri:`,
  'MobileContainer.mobileBIMessage.txt': () => `Pristupajte SAS izveštajima na mobilnom uređaju.`,
  'ObjectTypes.report.txt': () => `Izveštaj`,
  'ObjectTypes.Report.BI.txt': () => `SAS izveštaj (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored process report`,
  'ObjectTypes.StoredProcess.txt': () => `Uskladišteni proces`,
  'MissingValues.label.txt': () => `(vrednosti koje nedostaju)`,
  'PromptContainer.apply.txt': () => `U redu`,
  'PromptContainer.cancel.txt': () => `Otkaži`,
  'PromptContainer.close.txt': () => `Zatvori`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Vrednost mora biti broj između (uključujući) ${min} i ${max}.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Navedite važeću numeričku vrednost.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Vrednost nije važeća za dodeljene podatke.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Unesite: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Unesite: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Unesite ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min}–${max}`,
  'Slider.missingValues.txt': () => `Vrednosti koje nedostaju`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Nazad`,
  'ReportContainer.reportCorrupted.txt': () => `IZVEŠTAJ JE OŠTEĆEN`,
  'ReportContainer.themeLoadFailed.txt': () => `Učitavanje teme izveštaja nije uspelo.`,
  'ReportContainer.restoreButton.tip.txt': () => `Vrati izveštaj`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Izveštaj vraćen`,
  'ReportContainer.renderError.txt': () => `Došlo je do greške. Nije moguće prikazati izveštaj.`,
  'ReportContainer.component.renderError.txt': () => `Došlo je do greške. Nije moguće prikazati komponentu.`,
  'ReportContentPage.open.txt': () => `Otvori...`,
  'ReportContentPage.refreshReport.txt': () => `Osveži izveštaj`,
  'ReportContentPage.editReport.txt': () => `Uredi izveštaj`,
  'ReportContentPage.print.txt': () => `Štampanje...`,
  'ReportContentPage.email.txt': () => `E-pošta...`,
  'ReportContentPage.export.txt': () => `Izvezi u Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Svojstva izveštaja`,
  'ReportContentPage.shareReport.txt': () => `Deljenje izveštaja`,
  'ReportContentPage.enableOverlays.txt': () => `Omogući prekrivke objekta`,
  'ReportContentPage.disableOverlays.txt': () => `Onemogući prekrivke objekta`,
  'ReportContentPage.link.txt': () => `Povezivanje...`,
  'ReportContentPage.settings.txt': () => `Postavke...`,
  'ReportContentPage.editPlayback.txt': () => `Uredi reprodukciju`,
  'ReportContentPage.playReport.txt': () => `Reprodukuj izveštaj`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Prikaži filtere sa predefinisanim opcijama`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Sakrij filtere sa predefinisanim opcijama`,
  'ReportContentPage.reportFilters.txt': () => `Nivo izveštaja`,
  'ReportContentPage.pageFilters.txt': () => `Nivo stranice`,
  'ReportContentPage.refreshRequired.txt': () => `Potrebno je osvežiti izveštaj`,
  'ReportContentPage.infoButton.tip.txt': () => `Tabla sa informacijama`,
  'ReportContentPage.backButton.tip.txt': () => `Prikaži sve izveštaje`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Više opcija`,
  'ReportContentPage.itemGroupName.txt': () => `Izveštaji`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Uvećaj izveštaj`,
  'ReportContentPage.closeButton.txt': () => `Zatvori izveštaj`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Izveštaj uvećan`,
  'ReportContentPage.resetReportState.txt': () => `Vrati podrazumevano stanje izveštaja`,
  'ReportContentPage.summary.txt': () => `Prikaži rezime`,
  'ReportManagerPage.objectMenu.open.txt': () => `Otvori`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Uredi`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Rezime`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Svojstva`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-pošta...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Štampaj`,
  'ReportManagerPage.browseReportsButton.txt': () => `Pregledajte izveštaje`,
  'ReportManagerPage.newReportButton.txt': () => `Novi izveštaj`,
  'ReportManagerPage.emptyView.message.txt': () => `Nema pronađenih izveštaja.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Pregledanje izveštaja`,
  'ReportManagerPage.tableView.name.txt': () => `Ime`,
  'ReportManagerPage.tableView.author.txt': () => `Autor`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Poslednja izmena`,
  'ReportManagerPage.openButton.tip.txt': () => `Otvori izveštaj`,
  'ReportManagerPage.emailButton.tip.txt': () => `Pošalji izveštaj e-poštom`,
  'ReportManagerPage.printButton.tip.txt': () => `Odštampaj izveštaj u PDF formatu`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Svojstva izveštaja`,
  'ReportObject.multipleReferences.error.txt': () => `Objekti izveštaja ne mogu da se koriste u više konteksta.`,
  'ReportObject.notFound.error.txt': () => `Ne može se pronaći ime objekta u navedenom izveštaju.`,
  'ReportObject.invalidPage.error.txt': () => `Navedena stranica je nevažeća.`,
  'ReportPropertiesDialog.open.txt': () => `Otvori`,
  'ReportPropertiesDialog.close.txt': () => `Zatvori`,
  'ReportPropertiesDialog.name.txt': () => `Ime:`,
  'ReportPropertiesDialog.description.txt': () => `Opis:`,
  'ReportPropertiesDialog.keywords.txt': () => `Ključne reči:`,
  'ReportPropertiesDialog.type.txt': () => `Tip:`,
  'ReportPropertiesDialog.location.txt': () => `Lokacija:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Kreirao/la:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Datum kreiranja:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Izmenio/la:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Datum izmene:`,
  'ReportSections.newPageButton.txt': () => `Nova stranica`,
  'ReportSections.closeTab.tooltip.txt': () => `Izbriši stranicu`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `${label} meni`,
  'ReportSummaryDialog.title.txt': () => `Rezime`,
  'ReportSummaryDialog.open.txt': () => `Otvori`,
  'ReportSummaryDialog.cancel.txt': () => `Otkaži`,
  'ReportSummaryDialog.close.txt': () => `Zatvori`,
  'ReportSummaryDialog.noSummary.txt': () => `Nema dostupnih rezimea.`,
  'ReportTileBody.modifiedBy.txt': () => `Izmenio/la:`,
  'ReportTileBody.lastModified.txt': () => `Poslednja izmena:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `Prikazivač SAS izveštaja`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Osvežavanje izveštaja`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Automatsko osvežavanje izveštaja`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Proveri da li ima dostupnih ažuriranja po isteku ovog broja minuta:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Upozorenja`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Izaberite podrazumevana obaveštenja o upozorenjima:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Šalji e-poruke`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Šalji SMS tekstualne poruke`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Podrazumevani administrator`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Teme`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Zamenite temu izveštaja i koristite SAS High Contrast temu izveštaja`,
  'ViewerBusyDialog.openReport.txt': () => `Otvaranje izveštaja...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Priprema izvoza...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Priprema štampanja...`,
  'PDFGeneration.printingReport.txt': () => `Generisanje izveštaja u PDF formatu. Biće preuzet kada bude spreman.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} dana ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Izaberite radnju`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Dostigli ste najniži nivo u hijerarhiji.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Dostigli ste najniži nivo u svim hijerarhijama.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Dubinski pretraži ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Trenutna slika ${a0} ${a1} na ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Sačuvaj sliku`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Štampanje objekta...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Delite objekat...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Više`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Meni za objekte za ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Prikaži koristeći SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Zumiraj`,
  'ZoomControl.button.zoomin.txt': () => `Uvećaj`,
  'ZoomControl.button.zoomout.txt': () => `Umanji`,
  'ZoomControl.button.display.txt': () => `Kontrole zumiranja`,
  'ZoomControl.button.reset.txt': () => `Ponovo postavi zumiranje`,
  'ExpandControl.button.expand.txt': () => `Uvećaj prikaz`,
  'ExpandControl.button.restore.txt': () => `Vrati prikaz`,
  'ExpandControl.button.expand.tip.txt': () => `Uvećaj`,
  'ExpandControl.button.restore.tip.txt': () => `Vrati`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Veze stranice ne mogu da se izvršavaju dok je ovaj objekat uvećan.`,
  'DragModeControl.button.pan.tip.txt': () => `Pomeranje`,
  'DragModeControl.button.circular.tip.txt': () => `Kružni izbor`,
  'DragModeControl.button.freeform.tip.txt': () => `Izbor slobodnog oblika`,
  'DragModeControl.button.rectangular.tip.txt': () => `Pravougaoni izbor`,
  'DragModeControl.button.zoom.tip.txt': () => `Zumiraj pravougaonik`,
  'ReportXMLDialog.title.txt': () => `XML datoteka sa izveštajem`,
  'ReportXMLDialog.closeButton.txt': () => `Zatvori`,
  'ReportXMLDialog.copyButton.txt': () => `Kopiraj u ostavu`,
  'ReportXMLDialog.error.txt': () => `Greška pri učitavanju XML datoteke sa izveštajem`,
  'ErrorDialog.error.txt': () => `Došlo je do greške. Obratite se administratoru sistema.`,
  'Application.banner.txt': () => `Prikazivač SAS® izveštaja`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics – prikazivač izveštaja`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Otvori izveštaj`,
  'OpenReportDialog.reports.txt': () => `Izveštaji:`,
  'OpenReportDialog.cancel.txt': () => `Otkaži`,
  'OpenReportDialog.ok.txt': () => `U REDU`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `Broj ažuriranih objekata: ${count}`,
  'AriaLive.oneObjectUpdated.txt': () => `1 ažurirani objekat`,
  'AriaLive.reportOpened.txt': () => `Izveštaj je otvoren`,
  'AriaLive.reportClosed.txt': () => `Izveštaj je zatvoren`,
  'ExportData.generating.txt': () => `Generisanje izveštaja. Biće preuzet kada bude spreman.`,
  'ExportData.warning.txt': () => `Greška pri generisanju podataka`,
  'ExportData.nodata.txt': () => `Nema podataka za izvoz`,
  'ExportData.exportData.txt': () => `Izvoz podataka...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Sačuvaj`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Otkaži`,
  'PlaybackAnimationDialog.playButton.txt': () => `Reprodukuj izveštaj`,
  'PlaybackAnimationDialog.title.txt': () => `Uredi reprodukciju`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Prelazna jedinica:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Stranica`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Objekat`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Sekunde po jedinici:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Prikaži uvećane objekte:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Prikaži samo podlogu:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Prikaži tajmer:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Prikaži kontrole navigacije na klik ili dodir:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Prethodna stranica`,
  'PlaybackNavigationControls.nextPage.txt': () => `Sledeća stranica`,
  'PlaybackNavigationControls.previousObject.txt': () => `Prethodni objekat`,
  'PlaybackNavigationControls.nextObject.txt': () => `Sledeći objekat`,
  'TransportConnection.generateReportTimeout.txt': () => `Izveštaj se dugo učitava. Želite li da nastavite?`,
  'TransportConnection.openReport.txt': () => `Otvori izveštaj`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Navedeni izveštaj ne postoji na sledećoj lokaciji: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Razvij ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Skupi ${label}`,
  'GraphElementDecorator.overview.txt': () => `Pregled`,
  'GraphElementDecorator.layers.txt': () => `Sakrij ili prikaži slojeve`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Sakrij pregled`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Prikaži pregled`,
  'TitleInfoButton.tooltip.txt': () => `Informacije`,
  'SectionSelectionBar.noSelections.txt': () => `Ništa nije izabrano`,
  'SectionSelectionBar.title.txt': () => `Filteri:`,
  'CheckboxList.selectAll.txt': () => `Izaberi sve`,
  'CheckboxList.clearSelection.txt': () => `Obriši izbor`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Obriši izbor (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Objašnjenje ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Priprema objašnjenja...`,
  'ExplanationInfoDialog.cancel.txt': () => `Otkaži`,
  'ExplanationInfoDialog.close.txt': () => `Zatvori`,
  'PromptHeader.emptyReport.txt': () => `Ovde otpustite stavku podataka ili kontrolu za kreiranje odzivnika izveštaja.`,
  'PromptHeader.emptyPage.txt': () => `Ovde otpustite stavku podataka ili kontrolu za kreiranje odzivnika stranice.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Skupi oblast kontrole stranice`,
  'PromptHeader.expandPageControlArea.txt': () => `Razvij oblast kontrole stranice`,
  'PromptHeader.collapseReportControlArea.txt': () => `Skupi oblast kontrole izveštaja`,
  'PromptHeader.expandReportControlArea.txt': () => `Razvij oblast kontrole izveštaja`,
  'PromptHeader.collapseControlArea.txt': () => `Skupi oblast kontrole`,
  'PromptHeader.expandControlArea.txt': () => `Razvij oblast kontrole`,
  'PromptHeader.reportControlArea.txt': () => `Oblast kontrole izveštaja`,
  'PromptHeader.allControlAreas.txt': () => `Sve oblasti kontrole`,
  'PromptHeader.pageControlArea.txt': () => `Oblast kontrole stranice`,
  'ZeroState.editMode.txt': () => `Ovde prevucite predložak, stavke podataka ili objekte.`,
  'ZeroState.viewMode.txt': () => `Nema sadržaja za prikaz.`,
  'ObjectStatus.assignData.txt': () => `Dodeli podatke`,
  'ObjectStatus.selectImage.txt': () => `Izaberite sliku`,
  'ObjectStatus.selectJob.txt': () => `Izaberite posao`,
  'ObjectStatus.cancelLoading.txt': () => `Otkaži učitavanje`,
  'ObjectStatus.loadingCanceled.txt': () => `Učitavanje je otkazano`,
  'ObjectStatus.resumeLoading.txt': () => `Nastavi sa učitavanjem`,
  'ObjectStatus.refresh.txt': () => `Osveži`,
  'ObjectStatus.setJobParameters.txt': () => `Postavi vrednosti parametara`,
  'ObjectSearch.title.txt': () => `Geografska pretraga`,
  'ObjectSearch.pin.txt': () => `Zakači`,
  'ObjectSearch.unpin.txt': () => `Otkači`,
  'MainSearchPanel.searchHints.txt': () => `Saveti za pretragu`,
  'MainSearchPanel.searchResults.txt': () => `Rezultati pretrage`,
  'MainSearchPanel.features.txt': () => `Funkcije`,
  'MainSearchPanel.pin.txt': () => `Nova pribadača`,
  'MainSearchPanel.pin.tooltip.txt': () => `Nova pribadača`,
  'MainSearchPanel.route.txt': () => `Nova ruta`,
  'MainSearchPanel.route.tooltip.txt': () => `Nova ruta`,
  'MainSearchPanel.geographicArea.txt': () => `Nova geografska oblast`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Nova geografska oblast`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Pribadača za moju lokaciju`,
  'MainSearchPanel.myLocationPin.txt': () => `Moja lokacija`,
  'MainSearchPanel.show.txt': () => `Prikaži`,
  'MainSearchPanel.show.all.txt': () => `Prikaži sve`,
  'MainSearchPanel.hide.txt': () => `Sakrij`,
  'MainSearchPanel.hide.all.txt': () => `Sakrij sve`,
  'MainSearchPanel.delete.txt': () => `Izbriši`,
  'MainSearchPanel.delete.all.txt': () => `Izbriši sve`,
  'MainSearchPanel.convert.txt': () => `Konvertuj rezultate pretrage u pribadače`,
  'MainSearchPanel.convert.all.txt': () => `Konvertuj sve rezultate pretrage u pribadače`,
  'MainSearchPanel.showPinLabels.txt': () => `Prikaži oznake pribadača`,
  'MainSearchPanel.close.label.txt': () => `Geografska pretraga`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Prikaži detalje`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Demografija`,
  'PanelHeader.back.tooltip.txt': () => `Nazad`,
  'GeographicAreaPanel.title.txt': () => `Geografska oblast`,
  'GeographicAreaPanel.draw.txt': () => `Iscrtaj oblast`,
  'GeographicAreaPanel.update.txt': () => `Ažuriraj oblast`,
  'GeographicAreaPanel.label.txt': () => `Oznaka:`,
  'GeographicAreaPanel.location.txt': () => `Lokacija:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Udaljenoset (mi):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Udaljenost (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Dodaj udaljenost`,
  'GeographicAreaPanel.time.add.txt': () => `Dodaj vreme`,
  'GeographicAreaPanel.distance.delete.txt': () => `Izbriši udaljenost`,
  'GeographicAreaPanel.time.minutes.txt': () => `Vreme (min):`,
  'GeographicAreaPanel.duration.txt': () => `Trajanje:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Milje`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometri`,
  'GeographicAreaPanel.menu.clear.txt': () => `Obriši geografsku oblast`,
  'GeographicAreaPanel.menu.link.txt': () => `Podrazumevano poveži adresu sa elementima podataka i pribadačama`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Raskini vezu sa adresom geografske oblasti`,
  'GeographicAreaPanel.menu.delete.txt': () => `Izbriši geografsku oblast`,
  'GeographicAreaPanel.demographics.txt': () => `Demografija`,
  'GeographicAreaPanel.demographics.set.txt': () => `Prikaži demografiju`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Razvij prikaz`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Uredi demografiju`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Izbriši demografiju`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Demografski podaci moraju ponovo da se učitaju`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Ponovo učitaj demografske podatke`,
  'GeographicAreaPanel.invalid.location.txt': () => `Geografska oblast nema važeću lokaciju i ne može da se kreira.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Izaberite dan i vreme`,
  'TravelTypeField.cancel.txt': () => `Otkaži`,
  'TravelTypeField.ok.txt': () => `U redu`,
  'TravelTypeField.button.tooltip.txt': () => `Izaberite dan i vreme`,
  'TravelTypeField.day.txt': () => `Dan:`,
  'TravelTypeField.time.txt': () => `Vreme:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Direktno`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Udaljenost`,
  'TravelTypeField.travelType.txt': () => `Tip putovanja:`,
  'TravelTypeField.traffic.txt': () => `Uključi saobraćaj:`,
  'TravelTypeField.traffic.offset.txt': () => `Pomak vremena saobraćaja:`,
  'TravelTypeField.traffic.daytime.txt': () => `Dan i vreme saobraćaja:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Jedinica za udaljenost`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Udaljenost za vožnju`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Vreme vožnje`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Udaljenost za transport`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Vreme transporta`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Udaljenost za pešačenje`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Vreme pešačenja`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Ne`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Aktuelni saobraćaj`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Tipični saobraćaj`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} č`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Ažuriraj saobraćaj za ovu funkciju`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Ažuriraj saobraćaj za sve funkcije`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Ažuriraj podatke o saobraćaju`,
  'RoutePanel.title.txt': () => `Ruta`,
  'RoutePanel.draw.txt': () => `Iscrtaj rutu`,
  'RoutePanel.update.txt': () => `Ažuriraj rutu`,
  'RoutePanel.label.txt': () => `Oznaka:`,
  'RoutePanel.locations.txt': () => `Lokacije`,
  'RoutePanel.menu.clear.txt': () => `Obriši rutu`,
  'RoutePanel.menu.reverse.txt': () => `Obrni rutu`,
  'RoutePanel.menu.add.waypoint.txt': () => `Dodaj lokaciju rute`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Izbriši lokaciju rute`,
  'RoutePanel.menu.unlink.txt': () => `Raskini vezu sa lokacijom rute`,
  'RoutePanel.menu.arrows.txt': () => `Strelice rute`,
  'RoutePanel.menu.arrows.hide.txt': () => `Sakrij strelice rute`,
  'RoutePanel.menu.arrows.show.txt': () => `Prikaži strelice rute`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Jednosmerno`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Dvosmerno`,
  'RoutePanel.menu.delete.txt': () => `Izbriši rutu`,
  'RoutePanel.route.width.txt': () => `Širina rute`,
  'RoutePanel.distance.txt': () => `Udaljenost:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} milja`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Dodaj lokaciju`,
  'RoutePanel.location.delete.txt': () => `Izbriši lokaciju`,
  'RoutePanel.duration.txt': () => `Vreme:`,
  'RoutePanel.invalid.location.txt': () => `Ruta nema važeće lokacije i ne može da se kreira.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Lokacija ${index}, ${location}, ulaz`,
  'PinPanel.pinTitle.txt': () => `Zakači`,
  'PinPanel.addDescription.txt': () => `Dodaj opis`,
  'PinPanel.deleteDescription.txt': () => `Izbriši opis`,
  'PinPanel.newPin.txt': () => `Nova pribadača na ovoj lokaciji`,
  'PinPanel.deletePin.txt': () => `Izbriši pribadaču`,
  'PinPanel.linkPins.txt': () => `Podrazumevano poveži pribadače sa elementima podataka`,
  'PinPanel.unlinkAllItems.txt': () => `Raskini vezu sa svim stavkama`,
  'PinPanel.unlinkItems.txt': () => `Raskini vezu sa stavkama`,
  'PinPanel.label.txt': () => `Oznaka:`,
  'PinPanel.location.txt': () => `Lokacija:`,
  'PinPanel.description.txt': () => `Opis:`,
  'PinPanel.linked.txt': () => `POVEZANO`,
  'PinPanel.searchClickPlaceholder.txt': () => `Pretražite ili izaberite na mapi`,
  'PinPanel.searchPlaceholder.txt': () => `Pretraži`,
  'PinPanel.addRoute.txt': () => `Dodaj rutu`,
  'PinPanel.addRoute.tooltip.txt': () => `Dodaj rutu`,
  'PinPanel.addArea.txt': () => `Dodaj geografsku oblast`,
  'PinPanel.addArea.tooltip.txt': () => `Dodaj geografsku oblast`,
  'PinPanel.addArea.title.txt': () => `Dodaj geografsku oblast`,
  'PinPanel.myLocationTitle.txt': () => `Pribadača za moju lokaciju`,
  'PinPanel.deleteMyLocationPin.txt': () => `Izbriši pribadaču za moju lokaciju`,
  'PinPanel.enableAutoUpdate.txt': () => `Omogući automatsko ažuriranje moje lokacije`,
  'PinPanel.disableAutoUpdate.txt': () => `Onemogući automatsko ažuriranje moje lokacije`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Uredi interval automatskog osvežavanja moje lokacije...`,
  'PinPanel.linkToPin.txt': () => `Poveži sa pribadačom`,
  'PinPanel.useCurrentLocation.txt': () => `Koristi trenutnu lokaciju pribadače`,
  'PinPanel.notDrawn.txt': () => `Nije iscrtano`,
  'PinPanel.undetermined.txt': () => `Neodređeno`,
  'PinPanel.findMyLocation.txt': () => `Pronađi moju lokaciju`,
  'PinPanel.cannotDetermineLocation.txt': () => `Aplikacija ne može da odredi vašu trenutnu lokaciju. Ako želite da delite svoju lokaciju, pogledajte pomoć za pregledač ili uređaj.`,
  'PinPanel.autoRefreshInterval.txt': () => `Interval automatskog osvežavanja moje lokacije`,
  'PinPanel.interval.hours.txt': () => `Sati:`,
  'PinPanel.interval.minutes.txt': () => `Minuti:`,
  'PinPanel.interval.seconds.txt': () => `Sekunde:`,
  'PinPanel.invalid.location.txt': () => `Pribadača nema važeću lokaciju i ne može da se kreira.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} milja`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} milja`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} milja`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min.`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min.`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min.`,
  'PinPanel.clearLocation.tooltip.txt': () => `Obriši tekst lokacije`,
  'DiscardChangesDialog.title.area.txt': () => `Geografska oblast`,
  'DiscardChangesDialog.title.route.txt': () => `Ruta`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Izmenili ste geografsku oblast, ali niste ponovo nacrtali oblast.\n\nŽelite li da odbacite promene unete u ${label}?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Izmenili ste geografsku rutu, ali niste ponovo nacrtali rutu.\n\nŽelite li da odbacite promene unete u ${label}?`,
  'DiscardChangesDialog.discard.txt': () => `Odbaci`,
  'DiscardChangesDialog.cancel.txt': () => `Otkaži`,
  'FeatureErrorDialog.title.area.txt': () => `Iscrtaj geografsku oblast`,
  'FeatureErrorDialog.title.route.txt': () => `Iscrtaj rutu`,
  'FeatureErrorDialog.text.area.txt': () => `Nije moguće iscrtati geografsku oblast.\n\nSavet: Ako lokacija vaše oblasti ne sadrži putnu infrastrukturu, poput puteva, možda neće biti moguće izračunati geografsku oblast. Umesto toga koristite tip putovanja na daljinu ili premestite oblast na lokaciju koja ima putnu infrastrukturu.`,
  'FeatureErrorDialog.text.route.txt': () => `Nije moguće iscrtati rutu.\n\nSavet: Ako lokacija vaše rute ne sadrži putnu infrastrukturu, poput puteva, možda neće biti moguće izračunati rutu. Umesto toga koristite tip putovanja na daljinu ili premestite rutu na lokaciju koja ima putnu infrastrukturu.`,
  'FeatureErrorDialog.close.txt': () => `Zatvori`,
  'DemographicsSelectorDialog.title.txt': () => `Prikaži demografiju`,
  'DemographicsSelectorDialog.cancel.txt': () => `Otkaži`,
  'DemographicsSelectorDialog.ok.txt': () => `U redu`,
  'DemographicsSelectorDialog.country.txt': () => `Zemlja/region`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Osnovno`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Više opcija`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Nedavno`,
  'DemographicsSelectorDialog.categories.txt': () => `Kategorije`,
  'DemographicsSelectorDialog.category.income.txt': () => `Prihod`,
  'DemographicsSelectorDialog.category.age.txt': () => `Starost`,
  'DemographicsSelectorDialog.category.households.txt': () => `Domaćinstva`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Stambena jedinica`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Bračni status`,
  'DemographicsSelectorDialog.category.population.txt': () => `Populacija`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Grupa korisnika`,
  'DemographicsSelectorDialog.category.health.txt': () => `Zdravlje`,
  'DemographicsSelectorDialog.category.education.txt': () => `Obrazovanje`,
  'DemographicsSelectorDialog.category.business.txt': () => `Zanimanje`,
  'DemographicsSelectorDialog.category.race.txt': () => `Rasa`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Troškovi`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Ponašanja`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Poslovi`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Siromaštvo`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Tapeti`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Rizično`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Ključne činjenice`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Ponuda i potražnja`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Smernice`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Predeo`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Kriminal`,
  'ManageColumns.title.txt': () => `Upravljanje kolonama`,
  'ManageColumns.ok.txt': () => `U redu`,
  'ManageColumns.cancel.txt': () => `Otkaži`,
  'ManageColumns.hiddenColumns.txt': () => `Skrivene kolone`,
  'ManageColumns.displayedColumns.txt': () => `Prikazane kolone`,
  'SearchResultPanel.title.txt': () => `Rezultat pretrage`,
  'SearchResultPanel.menu.delete.txt': () => `Izbriši rezultat pretrage`,
  'SearchResultPanel.convert.txt': () => `Konvertuj u pribadaču`,
  'SearchResultPanel.convert.tooltip.txt': () => `Konvertuj u pribadaču`,
  'DemographicsResultsDialog.title.txt': () => `Demografija`,
  'DemographicsResultsDialog.cancel.txt': () => `Otkaži`,
  'DemographicsResultsDialog.close.txt': () => `Zatvori`,
  'DemographicsResultsDialog.edit.txt': () => `Uredi`,
  'DemographicsResultsDialog.layout.page.txt': () => `Prikaz tipa vrteška`,
  'DemographicsResultsDialog.layout.list.txt': () => `Prikaz jedne kolone`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Prikaz pločice`,
  'DemographicsResultsDialog.noData.txt': () => `Nema podatka koji se podudaraju sa trenutnom geografskom oblašću.`,
  'PinsAtSameLocationPanel.title.txt': () => `Pribadače na istoj lokaciji`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `REZULTATI PRETRAGE`,
  'PinsAtSameLocationPanel.pins.txt': () => `PRIBADAČE`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Prikaži sve`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Sakrij sve`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Izbriši sve`,
  'PinsAtSameLocationPanel.show.txt': () => `Prikaži`,
  'PinsAtSameLocationPanel.hide.txt': () => `Sakrij`,
  'PinsAtSameLocationPanel.delete.txt': () => `Izbriši`,
  'LocationPopover.pin.title.txt': () => `Lokacija pribadače`,
  'LocationPopover.area.title.txt': () => `Lokacija geografske oblasti`,
  'LocationPopover.route.title.txt': ({label}) => `Lokacija rute ${label}`,
  'LocationPopover.name.txt': () => `Ime`,
  'LocationPopover.location.txt': () => `Lokacija:`,
  'LocationPopover.ok.txt': () => `Postavi lokaciju`,
  'LocationPopover.cancel.txt': () => `Izađi iz režima izbora`,
  'LocationPopover.hint.txt': () => `Kliknite ponovo na mapu da biste identifikovali drugu lokaciju.`,
  'TreeDualSelector.source.default.txt': () => `Dostupne stavke`,
  'TreeDualSelector.target.default.txt': () => `Izabrane stavke`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} od ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Nema stavki`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filter`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Prilagođena stavka`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `Dodate stavke: ${noOfSelectedRows}`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `Uklonjene stavke: ${noOfSelectedRows}`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Sve stavke su dodate`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Sve stavke su uklonjene`,
  'TreeDualSelector.afterAction.up.txt': () => `Premešteno nagore`,
  'TreeDualSelector.afterAction.down.txt': () => `Premešteno nadole`,
  'TreeDualSelector.afterAction.top.txt': () => `Premešteno na vrh`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Premešteno na dno`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Radnja dodavanja je vraćena`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Radnja uklanjanja je vraćena`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `prilagođena stavka je dodata`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} izabrana prilagođena stavka`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} izabrano`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} izabrano`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Premesti nagore za jedan red na ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Premesti nadole za jedan red na ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Premesti na vrh ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Premesti na dno ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Dodaj stavku na ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Dodaj sve na ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Ukloni stavku sa ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Ukloni sve sa ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Opozovi dodavanje za ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Opozovi uklanjanje za ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Filter ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Ukloni`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Prilagođene stavke koje ste izabrali za uklanjanje biće trajno izbrisane ako nastavite.\n\n Želite li da nastavite?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Ukloni sve stavke`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Prilagođene stavke na ovoj listi biće trajno izbrisane ako nastavite.\n\n Želite li da nastavite?`,
  'LinkNavigator.backButton.label': () => `Nazad`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Dolazni filteri`,
  'LinkNavigator.reportLevel.label': () => `Nivo izveštaja`,
  'LinkNavigator.sectionLevel.label': () => `Nivo stranice`,
  'ReportSectionZeroState.heading.label': () => `Dizajniranje izveštaja`,
  'ReportSectionZeroState.description.label': () => `Prevucite objekte ili stavke podataka na stranicu ili izaberite opciju u nastavku.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Prevucite objekte ili stavke podataka na stranicu ili počnite od predloška stranice.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Generiši objekat`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Izbor predloška`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Istraži predloge`,
  'PromptContainerTooltip.noSelections.txt': () => `Ništa nije izabrano`,
  'PromptContainerTooltip.selectedValues.txt': () => `Izabrane vrednosti`,
}
export default localizers;
